import { useMutation } from '@tanstack/react-query'

import { usersPasswordResetTfaSmsVerifyPost } from '@src/api'
import { DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useUsersPasswordResetTfaSmsVerifyPost = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest) =>
      usersPasswordResetTfaSmsVerifyPost(axiosInstance, params),
  })
}
